module.exports = __webpack_public_path__ + "img/inventory_by_store_locations.ab5a4ff6.svg";